import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
    failureGetLibraryScheduledClasses,
    successGetLibraryScheduledClasses,
} from "./LibraryScheduledClassesSlice";

// API call to fetch library scheduled classes
const GetLibraryScheduledClassesApi = () => {
    return api.get(`/api/library/scheduled-classes`);
};

// Saga
export function* LibraryScheduledClassesCall() {
    try {
        const response: AxiosResponse = yield call(GetLibraryScheduledClassesApi);
        yield put(successGetLibraryScheduledClasses(response.data));
    } catch (error: any) {
        yield put(failureGetLibraryScheduledClasses(error.response?.data || error.message));
    }
}
